import {BlockInteractor} from './ui/structure/StructurePresenter';
import {DefaultBlockInteractor} from './business/blocks/DefaultBlockInteractor';
import {lazy} from '../support/lazy';
import {Block} from './models/Block';
import {BlocksRepository} from './business/blocks/BlocksRepository';
import {ExpandedPartsProvider} from './business/expanded_parts/ExpandedPartsProvider';
import {DefaultExpandedPartsProvider} from './business/expanded_parts/DefaultExpandedPartsProvider';
import {PartEvent} from './models/PartEvent';
import {EventsRepository} from './business/events/EventsRepository';
import {DefaultEventInteractor} from './business/events/DefaultEventInteractor';
import {ChapterAdder, EventInteractor} from './ui/events/EventList/EventListPresenter';
import {MediaItemInteractor} from './ui/media/MediaItemList/MediaItemListPresenter';
import {DefaultMediaItemInteractor} from './business/media/DefaultMediaItemInteractor';
import {MediaItemsRepository} from './business/media/MediaItemsRepository';
import {MediaItem} from './models/MediaItem';
import {MediaProvider} from './business/media/MediaProvider';
import {MediaApi} from './network/MediaApi';
import {Chapter} from './models/Chapter';
import {ChaptersRepository} from './business/chapters/ChaptersRepository';
import {DefaultChapterInteractor} from './business/chapters/DefaultChaptersInteractor';
import {ChapterDeleter} from './ui/events/ChapterInsert/ChapterInsertPresenter';

export interface Component {
    organisationId: number | null;
    collectionId: number | null;
    blockInteractor: BlockInteractor & BlocksRepository;
    eventInteractor: EventsRepository & EventInteractor;
    chaptersInteractor: ChaptersRepository & ChapterDeleter & ChapterAdder;
    mediaItemsInteractor: MediaItemsRepository & MediaItemInteractor;
    expandedPartsProvider: ExpandedPartsProvider;
    mediaProvider: MediaProvider;
}

export class DefaultComponent implements Component {
    constructor(
        public organisationId: number | null,
        public collectionId: number | null,
        private initialBlocks: Block[],
        private initialEvents: PartEvent[],
        private initialChapters: Chapter[],
        private initialMediaItems: MediaItem[],
    ) {}

    @lazy()
    public get blockInteractor(): BlockInteractor & BlocksRepository {
        return new DefaultBlockInteractor(this.initialBlocks);
    }

    @lazy()
    public get expandedPartsProvider(): ExpandedPartsProvider {
        return new DefaultExpandedPartsProvider(this.blockInteractor);
    }

    @lazy()
    public get chaptersInteractor(): ChaptersRepository & ChapterDeleter & ChapterAdder {
        return new DefaultChapterInteractor(this.initialChapters);
    }

    @lazy()
    public get eventInteractor(): EventsRepository & EventInteractor {
        return new DefaultEventInteractor(this.initialEvents);
    }

    @lazy()
    public get mediaItemsInteractor(): MediaItemsRepository & MediaItemInteractor {
        return new DefaultMediaItemInteractor(this.initialMediaItems);
    }

    @lazy()
    public get mediaProvider(): MediaProvider {
        return new MediaProvider(new MediaApi());
    }
}

let instance: Component;

export function initialize(
    organisationId: number | null,
    collectionId: number | null,
    initialBlocks: Block[],
    initialEvents: PartEvent[],
    initialChapters: Chapter[],
    initialMediaItems: MediaItem[],
) {
    instance = new DefaultComponent(
        organisationId,
        collectionId,
        initialBlocks,
        initialEvents,
        initialChapters,
        initialMediaItems,
    );
}

export function component(): Component {
    if (instance === undefined) {
        throw new Error('Component not initialized');
    }

    return instance;
}
